import { z } from "zod";
/**
 * Mailing address. Country and state are stored as a resolved code + name pair
 * each: a caller may supply just a code or just a name (in any of the four
 * fields) and the backend derives the other via fuzzy matching at write time
 * (see @guestbook/shared/geo `resolveAddressGeo`). On a miss the raw text is
 * kept in the `*Name` field, the `*Code` is left null, and the contact is
 * tagged "Missing country" / "Missing state" for cleanup. No length/format
 * validation here — resolution, not the schema, owns correctness.
 */
export const addressSchema = z.object({
    line1: z.string().nullable().optional(),
    line2: z.string().nullable().optional(),
    city: z.string().nullable().optional(),
    postalCode: z.string().nullable().optional(),
    countryCode: z.string().nullable().optional(),
    countryName: z.string().nullable().optional(),
    stateCode: z.string().nullable().optional(),
    stateName: z.string().nullable().optional(),
});
//# sourceMappingURL=address.js.map